export default "__VITE_ASSET__DhCg7gW7__"